import { type SagaIterator } from "@redux-saga/core";
import { call, put, takeEvery } from "redux-saga/effects";
import  getOrderHistoryImage  from "../../services/orderhistoryimage/orderhistoryimage.api";
import {
  ImageDetails,
  ImagesPayload,
} from "../../types/orderhistoryimage";
import { PayloadAction } from "@reduxjs/toolkit";
import { withLoader } from "../loader/saga";
import { orderHistoryImageActions } from "../orderhistoryimage/slice";

export function* onGetOrderHistoryImage(
  action: PayloadAction<ImagesPayload>
): SagaIterator {
  try {
    const imageDetails: ImageDetails = yield* withLoader(function* () {
      return yield call(getOrderHistoryImage, action.payload);
    });
    yield put(orderHistoryImageActions.fetchImageSucceeded(imageDetails));
  } catch (e: unknown) {
    if (e instanceof Error) {
      yield put(orderHistoryImageActions.fetchImageFailure(e.message.toString()));
    }
  }
}


function* orderHistoryImageWatcherSaga(): SagaIterator {
  yield takeEvery(orderHistoryImageActions.fetchImageisLoading.type, onGetOrderHistoryImage);
}

function* resetImageDetails()
{
  yield put(orderHistoryImageActions.resetImageDetails()); // Dispatch reset action
}

function* imageDetailsWatcherSaga(): SagaIterator {
  yield takeEvery('CLEAR_IMAGEDETAILS', resetImageDetails);
}

export {orderHistoryImageWatcherSaga, imageDetailsWatcherSaga} ;
